import { LogoIcon } from "@volca/ui/components/ui/logo";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { InitiateVerificationResponse } from "@/payouts/payouts";

interface CreditClaimedProps {
  verificationData: InitiateVerificationResponse;
  isProcessing?: boolean;
}

export const CreditClaimed = ({
  verificationData,
  isProcessing = false,
}: CreditClaimedProps) => (
  <Stack
    role={isProcessing ? "status" : undefined}
    align="center"
    className="m-auto min-h-screen w-full max-w-md bg-surface-raised p-8"
    gap={8}
  >
    <LogoIcon />
    <Text variant="title" render={<h1 />}>
      {isProcessing
        ? "Processing your credit payment"
        : "Credit Payment Successful"}
    </Text>
    {isProcessing && <Spinner layout="centered" />}
    <Text className="text-center text-subtle">
      {isProcessing
        ? `Your credit is being added to your account. You will have access to it when you book a service at ${verificationData?.business_name}.`
        : `Your credit has been successfully added to your account. It will be available when you book a service at ${verificationData?.business_name}.`}
    </Text>
  </Stack>
);
